module.exports = __webpack_public_path__ + "img/order_request.c61c5837.png";